/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConflictTypeContractDto } from './conflictTypeContractDto.model';
import { ConflictContractDto } from './conflictContractDto.model';
import { ConflictTypeParcelAcreageDto } from './conflictTypeParcelAcreageDto.model';


export interface ConflictResponseDto { 
    contract?: ConflictContractDto;
    contractConflicts?: Array<ConflictTypeContractDto>;
    parcelAcreageConflicts?: Array<ConflictTypeParcelAcreageDto>;
}

